export default "__VITE_ASSET__taROLrGlP4I77buyhrbQxQ__"